import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { getSession } from '@app/selectors';
import type { RootState } from '@app/types';
import fetchServiceJwt from '@app/utils/lokaliseService/fetchServiceJwt';

// Define a base query function that fetches the JWT and includes it in the headers
const fetchJwtServiceBaseQuery = (baseUrl: string) =>
    fetchBaseQuery({
        baseUrl,
        prepareHeaders: async (headers, { getState }) => {
            const { projectId } = getSession(getState() as RootState);
            if (!projectId) {
                throw new Error('Project ID is not set');
            }

            const serviceJwt = await fetchServiceJwt(projectId);

            headers.set('authorization', `Bearer ${serviceJwt}`);

            return headers;
        },
    });

export default fetchJwtServiceBaseQuery;
